module.exports = __webpack_public_path__ + "static/media/AdvancedSearchCard.e24d369c.svg";